<template>
  <section class="personal">
    <form
      data-vv-scope="setPersonalForm"
      @submit.prevent="setPersonal('setPersonalForm')"
      class="personal-form"
    >
      <div class="form-block personal-password">
        <div class="form-group">
          <label for="new-password" class="label"
            >{{ $t("settings.newPassword") }}:</label
          >
          <input
            type="password"
            v-model="password"
            name="password"
            ref="password"
            v-validate="{
              required: passwordConfirm ? true : false,
              min: 6,
            }"
            id="new-password"
            class="input"
            :class="{ 'field-error': errors.has('setPersonalForm.password') }"
          />
          <label
            v-if="!errors.has('setPersonalForm.password')"
            for="new-password"
            class="label-tip"
            >{{ $t("settings.atLeastCharacters") }}</label
          >
          <label class="v-error label-tip">
            {{ errors.first("setPersonalForm.password") }}
          </label>
        </div>
        <div class="form-group">
          <label for="repeat-new-password" class="label"
            >{{ $t("settings.reissueNewPassword") }}:</label
          >
          <input
            type="password"
            v-model="passwordConfirm"
            name="passwordConfirm"
            v-validate="{
              required: password ? true : false,
              confirmed: password,
              min: 6,
            }"
            id="repeat-new-password"
            class="input"
            :class="{
              'field-error': errors.has('setPersonalForm.passwordConfirm'),
            }"
          />
          <label class="v-error label-tip">
            {{ errors.first("setPersonalForm.passwordConfirm") }}
          </label>
        </div>
      </div>
      <div class="form-block personal-email">
        <div v-if="user.email" class="form-group">
          <div class="label">{{ $t("settings.oldMail") }}:</div>
          <div class="current-value">{{ user.email }}</div>
        </div>
        <div class="form-group">
          <label for="new-email" class="label"
            >{{ $t("settings.newMail") }}:</label
          >
          <input
            type="text"
            v-model="email"
            name="email"
            v-validate="'email'"
            id="new-email"
            class="input"
            :class="{ 'field-error': errors.has('setPersonalForm.email') }"
          />
          <label
            v-if="!errors.has('setPersonalForm.email')"
            for="new-email"
            class="label-tip"
            >{{ $t("settings.confirmationEmailSent") }}</label
          >
          <label for="new-email" class="v-error label-tip">
            {{ errors.first("setPersonalForm.email") }}
          </label>
        </div>
      </div>
      <div class="form-block personal-phone">
        <div v-if="user.phone" class="form-group">
          <div class="label">{{ $t("settings.oldPhoneNumber") }}:</div>
          <div class="current-value">{{ user.phone }}</div>
        </div>
        <div class="form-group">
          <label for="new-phone" class="label"
            >{{ $t("settings.newPhoneNumber") }}:</label
          >
          <input
            type="text"
            v-model="phone"
            name="phone"
            v-validate="{
              regex: /^\+[0-9]{11,}$/,
              min: 11,
            }"
            id="new-phone"
            class="input"
            :class="{ 'field-error': errors.has('setPersonalForm.phone') }"
          />
          <label for="new-phone" class="v-error label-tip">
            {{ errors.first("setPersonalForm.phone") }}
          </label>
        </div>
      </div>
      <div class="buttons-row">
        <button
          @click="resetPersonalForm"
          type="button"
          class="button-secondary"
        >
          {{ $t("settings.cancel") }}
        </button>
        <button v-if="!loader" type="submit" class="button">
          {{ $t("settings.save") }}
        </button>
        <button
          v-if="loader"
          type="button"
          class="button button-loader"
        ></button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";

export default {
  name: "Personal",
  props: {
    i18n: Object,
  },
  mixins: [localizeValidation],
  data() {
    return {
      email: "",
      phone: "",
      password: "",
      passwordConfirm: "",
      loader: false,
    };
  },
  computed: {
    ...mapGetters({
      userIsEmpty: "user/isEmpty",
      user: "user/fetchUser",
      userErrors: "user/errors",
    }),
  },
  created() {
    this.localizeValidation();
  },
  methods: {
    setPersonal(scope) {
      if (this.password == "" && this.email == "" && this.phone == "") {
        return;
      }

      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.loader = true;
          const data = {
            password: this.password,
            email: this.email,
            phone: this.phone,
          };

          this.$store
            .dispatch("user/setPersonal", data)
            .then(() => {
              if (this.phone) {
                this.$modal.show("confirm-phone", {
                  phone: this.phone,
                });
              } else if (this.email) {
                this.$modal.show("dialog", {
                  title: this.$t("settings.success"),
                  text: this.$t("settings.followSpecifiedComplete"),
                  buttons: [
                    {
                      title: this.$t("roulette.ok"),
                    },
                  ],
                });
              }
              if (this.password) {
                this.$modal.show("dialog", {
                  text: this.$t("settings.theSuccessfullyChanged"),
                  buttons: [
                    {
                      title: this.$t("roulette.ok"),
                    },
                  ],
                });
                this.$store.dispatch("user/setEmpty");
                this.$router.push({ name: "home" });
              }
              this.resetPersonalForm();
              this.loader = false;
            })
            .catch(() => {
              if (typeof this.userErrors === "object") {
                for (let key in this.userErrors) {
                  this.errors.add({
                    field: scope + "." + key,
                    msg: this.userErrors[key][0],
                  });
                }
              }
              this.loader = false;
            });
        }
      });
    },
    resetPersonalForm() {
      this.email = "";
      this.phone = "";
      this.password = "";
      this.passwordConfirm = "";
      this.errors.clear();
      this.$validator.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/layout/_personal";
</style>
